import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AssignmentOutlined as TaskIcon } from '@mui/icons-material';
import PageHeader from '../../components/ui/PageHeader';
import PageBody from '../../components/ui/PageBody';
import { EmptyState } from '../../components/ui/States';
import { NavPanel } from '../../components/layout/NavPanel';

// Still a stub, but no longer advertised.
//
// This had a permanent slot in the sidebar that every AO could click, and
// clicking it produced "Task management page coming soon…". A tab that
// leads to an apology is worse than no tab, so it is hidden from the rail
// (navConfig, `hidden: true`) while keeping its route — anything already
// linking here still lands somewhere that explains itself.
const TaskList: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <NavPanel>
      </NavPanel>

      <PageBody>
        <PageHeader title="Tasks" subtitle="Not built for the web admin yet." />
        <EmptyState
          icon={<TaskIcon />}
          title="Tasks live on the phone"
          description="Assigning and completing tasks is a mobile job for v1. The web admin will get a planning view once the mobile side has settled."
          action={{ label: 'Back to dashboard', onClick: () => navigate('/dashboard') }}
        />
      </PageBody>
    </>
  );
};

export default TaskList;
